import { apiFetch } from './client';

export interface ContactPayload {
  type: 'request' | 'bug' | 'inquiry';
  subject: string;
  message: string;
  email?: string;
}

export async function submitContact(payload: ContactPayload): Promise<{ id: string }> {
  return apiFetch('/contact', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
